import React from 'react'
import { Link } from 'react-router-dom'
import './error.scss'
type Props = {

}
const ErrorPage: React.FC<Props> = () => {
    return (
        <div id="dn-404-page" className="container">
            <Link to="/" > Go to Homepage </Link>
        </div>)
}


export default ErrorPage;